<template>
  <div>
    <!-- 子订单信息 -->
    <el-card class="m-b">
      <div slot="header" class="clearfix">
        <span class="saas-card-header-name">子订单信息</span>
      </div>
      <div class="order-content-detail">
        <el-form
          :model="basicInfo"
          label-position="right"
          label-width="150px"
          :gutter="20"
          disabled
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="子订单编号：" prop="subOrderCode">
                <el-input v-model="basicInfo.subOrderCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="子订单状态：" prop="status">
                <span :class="[`sub-status-${basicInfo.status}`]">{{getValue('subOrderStatus', basicInfo.status)}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="来源主订单编号：" prop="orderCode">
                <el-input v-model="basicInfo.orderCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="来源主订单：" prop="orderName" class="form-items__btn">
                <el-input v-model="basicInfo.orderName"></el-input>
                <span class="detail-btn" @click="skipDetailPage">详情</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="主订单种类：" prop="orderType">
                <el-radio-group v-model="basicInfo.orderType">
                  <el-radio
                    v-for="(value, id) in enums.orderCategory"
                    :key="id"
                    :label="id">
                    {{value}}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="电子到货验收单：" prop="certFileId">
                <span class="form-items__blue" @click="selectArrivalDialog">{{basicInfo.certFileId ? basicInfo.fileList && basicInfo.fileList.length && basicInfo.fileList[0].name : '电子到货验收单.pdf'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <!-- 交货信息 -->
    <el-card class="m-b">
      <div slot="header" class="clearfix">
        <span class="saas-card-header-name">交货信息</span>
      </div>
      <div class="order-content-detail">
        <el-form
          :model="basicInfo"
          label-position="right"
          label-width="160px"
          :gutter="20"
          disabled
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="供应商联系人：" prop="contactName">
                <el-input v-model="basicInfo.contactName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="供应商联系人电话:" prop="contactPhone">
                <el-input v-model="basicInfo.contactPhone">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <template v-if="basicInfo.orderType == 1 && basicInfo.logistics">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="物流公司名称：" prop="corpName">
                  <el-input v-model="basicInfo.logistics.corpName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="物流单号：" prop="trackNumber">
                  <el-input v-model="basicInfo.logistics.trackNumber"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="货物承运人：" prop="driverInfo">
                  <el-input v-model="basicInfo.logistics.driverInfo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="货物承运人联系电话：" prop="driverPhone">
                  <el-input v-model="basicInfo.logistics.driverPhone">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="车辆信息：" prop="truckInfo">
                  <el-input v-model="basicInfo.logistics.truckInfo" placeholder="请输入车辆信息"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="`${basicInfo.orderType == 1 ? '发货时间:' : '服务开始时间:'}`" prop="startTime">
                <el-date-picker
                  class="w100"
                  v-model="basicInfo.startTime"
                  type="datetime"
                  :placeholder="`${basicInfo.orderType == 1 ? '发货时间' : '服务开始时间'}`"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="`${basicInfo.orderType == 1 ? '预计到货时间:' : '服务结束时间:'}`" prop="endTime">
                <el-date-picker
                  class="w100"
                  v-model="basicInfo.endTime"
                  type="datetime"
                  :placeholder="`${basicInfo.orderType == 1 ? '预计到货时间' : '服务结束时间'}`"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import { enums, getValue } from '@/lib/enum'
import arrivalOrderCertDialog from '@/components/dialog/arrivalOrderCertDialog.vue'
export default {
  props: {
    baseInfo: {
      type: [String, Object],
      default: ''
    }
  },
  data() {
    return {
      enums,
      getValue,
      basicInfo: {} // 第一步基本信息
    }
  },
  watch: {
    baseInfo(val) {
      this.basicInfo = val
      this.basicInfo.orderType = val.orderType.toString()
    }
  },
  methods: {
    // 查看电子到货验收单
    selectArrivalDialog() {
      this.$zl.dialog.openFull(arrivalOrderCertDialog, {
        subOrderId: this.basicInfo.id,
        system: this.$store.state.system
      }).then((res) => {
      })
    },
    // 跳转主订单详情
    skipDetailPage() {
      this.$router.push({
        name: `${this.$store.state.system === 'purchaser' ? 'OrderCheck' : 'SupplierOrderCheck'}`,
        query: {
          id: this.basicInfo.orderId,
          orderType: this.basicInfo.orderType,
          type: 'check'
        }
        // params: {
        //   isReLoad: true
        // }
      })
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/css/order.scss';
</style>
